// extracted by mini-css-extract-plugin
module.exports = {"mSizingGuide":"Fg","bold":"Gg","tableContainer":"Hg","selected":"Ig","sizePicker":"Jg","error":"Kg","disabled":"Lg","top":"Mg","typeOneSelect":"Ng","arrow":"Og","bottom":"Pg"};